import moment from 'moment-timezone';
import uniqid from 'uniqid';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';

const INTERNAL_ID_PREFIX = 'internal-';

const newInternalId = () => `${INTERNAL_ID_PREFIX}${uniqid()}`;

const isIdInternal = (id) => id && id.lastIndexOf(INTERNAL_ID_PREFIX, 0) === 0;

const fileStorage = {
  // file schema
  /*
    file: obj,
    fileName: string,
    dateAdded: date string
  */
};

const markedForDeletion = [];

const warningDoesNotFitSchema = (file) => {
  if (file.fileName === undefined) {
    console.warn('File uploaded must have a name');
  }
};


const fileDb = {
  save({
    id,
    file,
  }) {
    warningDoesNotFitSchema(file);
    fileStorage[id] = {
      ...file,
      dateAdded: file.dateAdded ? file.dateAdded : moment.tz(DEFAULT_TIMEZONE).format(),
    };
  },
  delete(params) {
    // FN: I wanted to keep it consistant with passing in objects but also there's only one value here so :shrugs:
    const id = params.id ? params.id : params;
    if (fileStorage[id]) {
      delete fileStorage[id];
    }
    else {
      console.warn(`Unable to find file id: ${id} in fileStorage at time of fileDb.delete()`);
    }
  },
  get(params) {
    if (!params) {
      return null;
    }
    // FN: I wanted to keep it consistant with passing in objects but also there's only one value here so :shrugs:
    const id = params.id ? params.id : params;
    return fileStorage[id];
  },
  getAll() {
    return fileStorage;
  },
  /*
    markForDeletion is used for adding items to an array. Then once deleteAllMarked is called, all items in this
    array are deleted. An item can be removed from this array by calling 'unMarkForDeletion' with it's id as a param
  */
  markForDeletion(params) {
    const id = params.id ? params.id : params;
    const itemAlreadyMarked = markedForDeletion.includes(id);
    if (id === undefined || itemAlreadyMarked) {
      return null;
    }
    markedForDeletion.push(id);
    return null;
  },
  unMarkForDeletion(params) {
    const id = params.id ? params.id : params;
    if (id === undefined) {
      return null;
    }
    const index = markedForDeletion.indexOf(id);
    if (index > -1) {
      markedForDeletion.splice(index, 1);
    }
    return null;
  },
  deleteAllMarked() {
    markedForDeletion.forEach((id) => {
      this.delete(id);
    });
    // clears the array after deleting all the items
    this.clearAllMarked();
  },
  clearAllMarked() {
    markedForDeletion.splice(0, markedForDeletion.length);
  },
};

export {
  fileDb,
  newInternalId,
  isIdInternal,
};
